import {
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
} from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { select, Store } from "@ngrx/store";
import { ACTION, AppState } from "libs/tm-common/src/lib";
import {
	MichiganSplintQuestionnaireDataRecord,
	MichiganSplintQuestionnaireSection,
	VerticalDimensionAnswerOption
} from "libs/questionaire/src/lib/michigan-splint/models/questionnaire-michigan-splint.model";
import { Product } from "libs/product/src/lib";
import { selectAnamneseQuestionnaireMichiganSplintAnswers } from "libs/anamnese/src/lib/store/anamnese.selectors";
import { take } from "rxjs";

@Component({
	selector: "tm2-anamnese-questionnaire-michigan",
	templateUrl: "./anamnese-questionnaire-michigan.component.html",
	styleUrl: "./anamnese-questionnaire-michigan.component.scss"
})
export class AnamneseQuestionnaireMichiganComponent implements OnInit {
	@Input({ required: true }) product: Product;
	@Output() next = new EventEmitter<any>();

	MichiganSplintQuestionnaireSection = MichiganSplintQuestionnaireSection;
	MichiganSplintQuestionnaireDataRecord = MichiganSplintQuestionnaireDataRecord;

	VerticalDimensionAnswerOption = VerticalDimensionAnswerOption;

	requiredOptionTextFormGroup = {
		option: [null, Validators.required],
		text: [null]
	};

	questionnaireForm: FormGroup = this.formBuilder.group({
		verticalDimension: this.formBuilder.group(this.requiredOptionTextFormGroup),
		individualComments: [null]
	});

	dimensionOptionFormControl: FormControl;
	dimensionTextFormControl: FormControl;

	constructor(
		private formBuilder: FormBuilder,
		private store: Store<AppState>
	) {}

	ngOnInit(): void {
		this.store.pipe(
				select(selectAnamneseQuestionnaireMichiganSplintAnswers),
				take(1)
			)
			.subscribe(answers => {
				if(answers){
					this.questionnaireForm.patchValue( answers );
				}
			});

		this.dimensionOptionFormControl = this.questionnaireForm.get(
			"verticalDimension.option"
		) as FormControl;
		this.dimensionTextFormControl = this.questionnaireForm.get(
			"verticalDimension.text"
		) as FormControl;

		if (this.dimensionTextFormControl?.value) {
			this.dimensionTextFormControl?.enable({ emitEvent: false });
		} else {
			this.dimensionTextFormControl?.disable({ emitEvent: false });
		}

		this.dimensionOptionFormControl?.valueChanges.subscribe((value) =>
			this.onVerticalDimensionChange(value)
		);
	}

	protected checkValid(): boolean {
		return this.questionnaireForm.valid;
	}

	onAction($event) {
		switch ($event.type) {
			case ACTION.NEXT:
				let payload = this.questionnaireForm.value;
				this.next.emit({ type: ACTION.QUESTIONAIRE, payload });
				break;
			case ACTION.BACK:
				this.next.emit({ type: ACTION.BACK });
		}
	}

	private onVerticalDimensionChange(value: VerticalDimensionAnswerOption) {
		if (value === VerticalDimensionAnswerOption.ADJUST_BY_MM) {
			this.dimensionTextFormControl?.enable({ emitEvent: false });
			this.dimensionTextFormControl?.setValidators([Validators.required]);
			this.dimensionTextFormControl?.markAsTouched();
		} else {
			this.dimensionTextFormControl?.patchValue("", { emitEvent: false });
			this.dimensionTextFormControl?.disable({ emitEvent: false });
			this.dimensionTextFormControl?.clearValidators();
		}
		this.dimensionTextFormControl?.updateValueAndValidity();
	}

	protected getHeadline(section: MichiganSplintQuestionnaireSection): string {
		return MichiganSplintQuestionnaireDataRecord[section].headline;
	}

	get verticalDimension() {
		return this.questionnaireForm.get("verticalDimension");
	}
}
